import { render, staticRenderFns } from "./chateau-pedesclaux.vue?vue&type=template&id=53fdd3f2&scoped=true"
import script from "./chateau-pedesclaux.vue?vue&type=script&lang=js"
export * from "./chateau-pedesclaux.vue?vue&type=script&lang=js"
import style0 from "./chateau-pedesclaux.vue?vue&type=style&index=0&id=53fdd3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fdd3f2",
  null
  
)

export default component.exports